// extracted by mini-css-extract-plugin
export default {"body-1":"ULGKcJImXg3KE1hUeTvA","body-2":"voftM5oYjLE2FKgNahMb","body-3":"xYJsLMZUsBOaivU3cbNg","ant-typography":"KVx0ZRJGlmpJF7sxfvoX","text":"A9QOGodBfho8xG3cWR6X"};